module.exports = __webpack_public_path__ + "img/h1@2x.f7a6de36.png";